module.exports = __webpack_public_path__ + "resources/img/equipment_tab_img5_m.78433e190c1e5410978b716d00c2be20.jpg";